import { InfoPageModel } from "api"
import TextsPage from "./TextsPage"

type ethicsProps = {
  data: InfoPageModel
}

const EthicsPage = ({ data }: ethicsProps) => (
  <TextsPage title={data?.title} text={data?.body} />
)

export default EthicsPage
